import styled, { css } from 'styled-components';

export const ArrowContainer = styled.div<{ isRightArrow?: boolean }>`
  width: 100px;
  height: 100%;
  position: absolute;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  cursor: pointer;

  ${({ isRightArrow }) =>
    isRightArrow
      ? css`
          background: linear-gradient(270deg, #fff 50%, rgba(245, 245, 245, 0) 100%);
          right: 0;
          justify-content: right;
          div {
            margin-right: 16px;
            img {
              transform: rotate(270deg);
              margin-left: 2px;
            }
          }
        `
      : css`
          background: linear-gradient(90deg, #fff 50%, rgba(245, 245, 245, 0) 100%);
          left: 0;
          justify-content: left;
          div {
            margin-left: 16px;
            img {
              transform: rotate(90deg);
              margin-right: 2px;
            }
          }
        `}
`;

export const ArrowCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  &:hover {
    background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  }
`;
